(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-us"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function() {
 var col_n = $('.ourteam_slider').data('column');
if($(".ourteam_slider .owl-nav").hasClass('disabled')){
 jQuery(".our_team .customNavigation").show();
}else{
 jQuery(".our_team .customNavigation").show();
}
 $('body:not(.rtl) .ourteam_wrap .ourteam_slider').owlCarousel({
              items : col_n, //1 items above 1000px browser width
              nav : true,
              dots : false,
			loop: true,
           responsive: {
            480: {
              items: 1
            },
            767: {
              items: 2
            },
            900: {
              items: 3
            },
            1280: {
              items: col_n
            }
          }
          });
$('body.rtl .ourteam_wrap .ourteam_slider').owlCarousel({
              items : col_n, //1 items above 1000px browser width
              nav : true,
				rtl:true,
			  loop: true,
              dots : false,
           responsive: {
            480: {
              items: 1
            },
            767: {
              items: 2
            },
            900: {
              items: 3
            },
            1280: {
              items: col_n
            }
          }
          });
       jQuery(".our_team .customNavigation .next").click(function(){
        jQuery('.our_team .ourteam_slider').trigger('next.owl');
      });
      jQuery(".our_team .customNavigation .prev").click(function(){
        jQuery('.our_team .ourteam_slider').trigger('prev.owl');
      }); 
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-category"]) return;
  try {
    
$(document).ready(function(){
$(".dt-menu-expand").click(function(event){
event.preventDefault();
if( $(this).hasClass("dt-mean-clicked") ){
$(this).text("+");
if( $(this).parent().next('ul').length ) {
$(this).parent().next('ul').slideUp(400);
} else {
$(this).parent().next('.megamenu-child-container').find('ul:first').slideUp(600);
}
} else {
$(this).text("-");
if( $(this).parent().next('ul').length ) {
$(this).parent().next('ul').slideDown(400);
} else{
$(this).parent().next('.megamenu-child-container').find('ul:first').slideDown(2000);
}
}

$(this).toggleClass("dt-mean-clicked");
return false;
});

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-promoimage"]) return;
  try {
    
$(document).ready(function(){
     $("#promoimg-carousel").owlCarousel({ 
        items: 1,
        autoPlay: false,
        nav: false,
     responsive: {
          100: {
            items: 1
          },
          767: {
            items: 1
          },
          1199: {
            items: 1
          },
           1200: {
            items: 1
          }
        },
        nav: true,
        dots:true 
  });
});
      

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-2"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function() {
 $('body:not(.rtl) .tt-testimonial-wrap2 .testimonials_wrap').owlCarousel({
              items : 1, //1 items above 1000px browser width
              nav : true,
              dots : false,
              loop: true,
			  autoplay:true,
			  rtl:false,
              responsive: {
                      1279: {
                        items: 1
                      },
                      1250: {
                        items: 1
                      },
                      600: {
                        items: 1
                      }
                    }
          });
$('body.rtl .tt-testimonial-wrap2 .testimonials_wrap').owlCarousel({
              items : 1, //1 items above 1000px browser width
              nav : true,
              dots : false,
              loop: true,
			  autoplay:true,				
			  rtl:true,
              responsive: {
                      1279: {
                        items: 1
                      },
                      1250: {
                        items: 1
                      },
                      600: {
                        items: 1
                      }
                    }
          });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-section"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function() {
 $('body:not(.rtl) .tt-testimonial-wrap .testimonials_wrap').owlCarousel({
              items : 1, //1 items above 1000px browser width
              nav : true,
              dots : false,
            responsive: {
                      1279: {
                        items: 1
                      },
                      1250: {
                        items: 1
                      },
                      600: {
                        items: 1
                      }
                    }
          });
 $('body.rtl .tt-testimonial-wrap .testimonials_wrap').owlCarousel({
              items : 1, //1 items above 1000px browser width
              nav : true,
              rtl: true,
              dots : false,
            responsive: {
                      1279: {
                        items: 1
                      },
                      1250: {
                        items: 1
                      },
                      600: {
                        items: 1
                      }
                    }
          });
});

  } catch(e) { console.error(e); }
})();
})();
